import Vue from 'vue'
import Router from 'vue-router'

//import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/item/:col/:id',
      name: 'item',
      component() { return import('./views/item.vue') },
      children: [
        {
          path: "pop/",
          name: "popup",
          component() { return import('./views/popup.vue') },
          meta: {
            showModal: true
          },
          children: [
            {
              path: 'up/:pcol/:pid',
              name: 'itemPopup',
              component() { return import('./views/item.vue') },
            },
          ]
        }
      ],
    },
    {
      path: '/list/:col',
      name: 'list',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component() {
        return import('./views/list.vue')
      }
    },
    {
      path: '/login',
      name: 'login',
      component() {
        return import('./views/login.vue')
      }
    },
    {
      path: '/register',
      name: 'register',
      component() {
        return import('./views/register.vue')
      }
    },
    {
      path: '/new-password',
      name: 'passwordNew',
      component() {
        return import('./views/passwordNew.vue')
      }
    },   {
      path: '/password-reset',
      name: 'passwordReset',
      component() {
        return import('./views/passwordReset.vue')
      }
    },
    {
      path: '/settings',
      name: 'settings',
      component() {
        return import('./views/settings.vue')
      }
    }
  ]
})
